export default __webpack_public_path__ + "static/media/linkedin.c61f38f6.svg";